import axios from "axios";

// When REACT_APP_BACKEND_URL is unset/empty the client uses a relative "/api"
// base (same-origin; the dev server or nginx proxies it to the backend).
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
